import { useState } from 'react';
import HotelSearch, { place } from '../../components/HotelSearch';
import UI from '../../ui';
import { Options, travelOptions } from '../../components/OptionsSelect';
import { useNavigate } from 'react-router';
import React from 'react';
import fetchers from '../../functions/fetch';
import { post, postsStore } from '../../mocks/postsMocks/postsStore';
import useUserState from '../../states/useUserState';
import useUser from '../../hooks/useUser';
import { images_db } from '../../components/PostImage';

type review = post['reviews'][0];
type feature = review['feature'];
type reviewObject = { [k in feature]?: string };
const ReviewMode: React.FC<{
  favoriteFeatures:
  feature[]
  reviews: reviewObject
  setReviews: (v: React.SetStateAction<reviewObject>) => void
  onPost: () => void
}> = ({ favoriteFeatures, reviews, setReviews, onPost }) => {
  return (
    <UI.VerticalLayout overflow="scroll">
      <UI.AccordionGroup
        items={favoriteFeatures.map(feature => ({
          label: feature,
          content: (
            <UI.Textfield
              value={reviews[feature] || ''}
              onChange={v => setReviews(prev => ({ ...prev, [feature]: v }))}
              placeHolder="Add your comments"
              multiline
            />
          ),
        }))}
      />
      <UI.Button label="Post" onClick={onPost} />
    </UI.VerticalLayout>
  );
};

const CreatePostPage: React.FC = () => {
  const navigate = useNavigate();
  const { userId } = useUserState();
  const user = useUser(userId || '4'); // manually using Sarah Alali's user (only for the demo)
  const [selectedHotel, setSelectedHotel] = useState<place | undefined>();
  const [pick, setPick] = useState<boolean | null>(null);
  const [caption, setCaption] = useState('');
  const [favoriteFeatures, setFavoriteFeatures] = useState<string[]>([]);
  const [reviewMode, setReviewMode] = useState(false);
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [reviews, setReviews] = useState<reviewObject>({});

  if (!userId || !user) return null;
  const country = selectedHotel?.address_components?.find(({ types }) => types.includes('country'))?.short_name as post['location']['country_code'];
  const city = selectedHotel?.address_components?.find(({ types }) => types.includes('administrative_area_level_1') || types.includes('administrative_area_level_2'))?.long_name;
  const lat = selectedHotel?.geometry?.location?.lat();
  const lng = selectedHotel?.geometry?.location?.lng();

  const onPost: () => void = () => {
    if (!selectedHotel || !city || !country || !lat || !lng) {
      console.log({ selectedHotel, city, country });
      return;
    }
    const id = postsStore.length; // this only works for the demo, otherwise id should be determined by the backend.
    const allReviews = Object.entries(reviews).map(([feature, description]) => ({ feature: feature as feature, description }));
    console.log('posting!');
    fetchers.create_post({
      id,
      comments: [],
      description: caption,
      hotelName: selectedHotel.name || '',
      hotelUrl: selectedHotel.url || '',
      images: uploadedImages.map(({ name }) => name),
      location: { city: city, country_code: country, lat: lat, lng: lng },
      pick: !!pick,
      reviews: allReviews,
      user_id: parseInt(userId),
      user_name: user.user.name,
    });
    // Manually updating a mock object containing all image files to refer to if it does not exist in the public/hotels folder. Quick hack for the demo
    uploadedImages.forEach(file => images_db[file.name] = file);
    navigate(`/posts/${id}`);
  };
  if (reviewMode) {
    return <ReviewMode favoriteFeatures={favoriteFeatures as feature[]} reviews={reviews} setReviews={setReviews} onPost={onPost} />;
  }
  return (
    <UI.VerticalLayout overflow="scroll" gap={16}>
      <UI.ImageUpload onSelect={setUploadedImages} />
      <HotelSearch onSelectedHotel={setSelectedHotel} clearOnSelect={false} />
      <UI.HorizontalLayout gap={5} align="center">
        <UI.Icon name="location_on" />
        <UI.Text>{selectedHotel?.formatted_address || '- -'}</UI.Text>
      </UI.HorizontalLayout>
      <Options title="Who did you travel with?" subtitle="Select who you traveled with" options={travelOptions.travelCompanions} max={1} />
      {/* <Options title="What was the purpose of your travel?" subtitle="Did you travel for business or leisure?" options={travelOptions.travelPurpose} max={1} /> */}
      <Options title="What was your travel style?" subtitle="Choose all that apply" options={travelOptions.travelStyles} />
      {/* FIXME: needs better typeguarding */}
      <Options title="Was this your favourite hotel in the city?" options={['Yes', 'No']} onSelect={v => setPick(v[0] === 'Yes')} max={1} />
      {pick === true && <Options title="Select the best 4 features of your stay" options={travelOptions.features} max={4} onSelect={setFavoriteFeatures} />}
      {pick === false && (
        <React.Fragment>
          <Options title="What traveler type would like this hotel the most?" options={travelOptions.travelCompanions} max={1} />
          <Options title="What traveler style would like this hotel the most?" options={travelOptions.travelStyles} max={1} />
        </React.Fragment>
      )}
      <UI.Textfield
        label="Caption"
        value={caption}
        onChange={setCaption}
        placeHolder="Add a caption"
        multiline
      />
      {pick
        ? <UI.Button disabled={favoriteFeatures.length === 0} label="Next" onClick={() => setReviewMode(true)} />
        : (
            <UI.Button
              label="Post"
              onClick={onPost}
            />
          )}
    </UI.VerticalLayout>
  );
};

export default CreatePostPage;
